/**
 * Quote Form Fields - Per-quote_kind field table for the shared quote modal
 *
 * @ui @slab-quote @shopify @product-page @modal
 *
 * One modal, one endpoint, four field sets (owner rulings 2026-09-28). This file holds everything
 * that VARIES between the field sets — which extra fields are required, and which flat fields go
 * into the payload's `quote_fields` object — plus the US state list the delivery block needs.
 * assets/slab-quote.js holds everything that does NOT vary (validation of the shared fields,
 * submission, success/error views) and stays under the 500-line cap.
 *
 * Loaded from snippets/slab-quote-modal.liquid BEFORE slab-quote.js (plain <script defer>, so the
 * order in the markup is the execution order). Exposed as window.SGIQuoteForms — a top-level
 * `const` is NOT a window property, so the assignment below is explicit.
 *
 * Payload contract: docs/plans/QUOTE_FORM_CONTRACT_2026-09-28.md — keep the two in sync.
 *
 * See Also: slab-quote.js, snippets/slab-quote-modal.liquid, snippets/sgi-price-mode.liquid
 */

(function () {
  'use strict';

  // ========================================================================
  // US state data (delivery country is always US for this form)
  // ========================================================================

  var US_STATES = [
    ["AL","Alabama"],["AK","Alaska"],["AZ","Arizona"],["AR","Arkansas"],
    ["CA","California"],["CO","Colorado"],["CT","Connecticut"],["DE","Delaware"],
    ["DC","District of Columbia"],["FL","Florida"],["GA","Georgia"],["HI","Hawaii"],
    ["ID","Idaho"],["IL","Illinois"],["IN","Indiana"],["IA","Iowa"],
    ["KS","Kansas"],["KY","Kentucky"],["LA","Louisiana"],["ME","Maine"],
    ["MD","Maryland"],["MA","Massachusetts"],["MI","Michigan"],["MN","Minnesota"],
    ["MS","Mississippi"],["MO","Missouri"],["MT","Montana"],["NE","Nebraska"],
    ["NV","Nevada"],["NH","New Hampshire"],["NJ","New Jersey"],["NM","New Mexico"],
    ["NY","New York"],["NC","North Carolina"],["ND","North Dakota"],["OH","Ohio"],
    ["OK","Oklahoma"],["OR","Oregon"],["PA","Pennsylvania"],["RI","Rhode Island"],
    ["SC","South Carolina"],["SD","South Dakota"],["TN","Tennessee"],["TX","Texas"],
    ["UT","Utah"],["VT","Vermont"],["VA","Virginia"],["WA","Washington"],
    ["WV","West Virginia"],["WI","Wisconsin"],["WY","Wyoming"]
  ];

  function populateStateSelect(select, selectedValue) {
    if (!select) return;
    select.innerHTML = '<option value="">Select state...</option>';
    for (var i = 0; i < US_STATES.length; i++) {
      var opt = document.createElement('option');
      opt.value = US_STATES[i][0];
      opt.textContent = US_STATES[i][1];
      if (selectedValue && US_STATES[i][0] === selectedValue) opt.selected = true;
      select.appendChild(opt);
    }
  }

  // ========================================================================
  // Per-quote_kind table
  // ========================================================================
  //
  //   full_ship  the ship-to-type radios + street address block are rendered (slab, general).
  //              When false the modal asks for a delivery ZIP only, so the address/state/city
  //              rules and the pickup branch do not apply.
  //   freight    the slab-only unloading-equipment + truck-access questions are rendered.
  //   requires   extra [field name, error message] pairs validated on top of the shared ones.
  //   extras     builds the flat `quote_fields` object for this kind. `g` is the accessor bag
  //              handed in by slab-quote.js: g.val / g.num / g.int / g.checked / g.radio.
  //
  // Every kind's `extras` returns the SAME keys for that kind (null when empty), so the backend
  // can rely on the shape rather than on key presence.

  var FORMS = {
    slab: {
      full_ship: true,
      freight: true,
      requires: [],
      extras: function () { return {}; }
    },

    general: {
      full_ship: true,
      freight: false,
      requires: [],
      extras: function () { return {}; }
    },

    field_tile: {
      full_ship: false,
      freight: false,
      requires: [
        ['tile_quantity', 'Quantity is required'],
        ['tile_quantity_unit', 'Quantity unit is required'],
        ['tile_application', 'Application is required'],
        ['project_type', 'Project type is required']
      ],
      extras: function (g) {
        return {
          size: g.val('tile_size') || null,
          quantity: g.num('tile_quantity'),
          quantity_unit: g.val('tile_quantity_unit') || null,
          application: g.val('tile_application') || null,
          project_type: g.val('project_type') || null,
          needed_by: g.val('needed_by') || null
        };
      }
    },

    molding: {
      full_ship: false,
      freight: false,
      requires: [
        ['linear_feet', 'Linear footage is required']
      ],
      extras: function (g) {
        return {
          linear_feet: g.num('linear_feet'),
          piece_length: g.val('piece_length') || null,
          quantity: g.int('molding_quantity'),
          needed_by: g.val('needed_by') || null
        };
      }
    }
  };

  function formConfig(kind) {
    return FORMS[kind] || FORMS.slab;
  }

  window.SGIQuoteForms = {
    US_STATES: US_STATES,
    populateStateSelect: populateStateSelect,
    FORMS: FORMS,
    formConfig: formConfig
  };
})();
